import { Link } from "react-router-dom";
import { Fragment } from "react";
import classes from "./Hero.module.css";
import { useContext } from "react";
import { CartContext } from "../../../CartContext";

const Hero = () => {
  const context = useContext(CartContext);
  return (
    <Fragment>
      <main className={classes.main}>
        <h1>Get Dripped!!!</h1>
        {context.isLoggedIn ? (
          <Link className={classes.button} to="/store">
            Start Dripping
          </Link>
        ) : (
          <Link className={classes.button} to="/login">
            Start Dripping
          </Link>
        )}
      </main>
    </Fragment>
  );
};

export default Hero;
